var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Multiselect",
    _vm._b(
      {
        class: {
          "multiselect--no-options": !_vm.places.length
        },
        attrs: {
          label: "description",
          "track-by": "description",
          placeholder: _vm.i18n.placeholder,
          options: _vm.places,
          loading: _vm.isLoading,
          disabled: false,
          multiple: false,
          searchable: true,
          "internal-search": false,
          "clear-on-select": true,
          "show-no-results": true,
          "show-no-options": false,
          "hide-selected": false,
          "allow-empty": true,
          "close-on-select": true
        },
        on: { "search-change": _vm.onChange, remove: _vm.onRemove },
        scopedSlots: _vm._u([
          {
            key: "singleLabel",
            fn: function(props) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(props.option.structured_formatting.main_text) +
                    "\n  "
                )
              ]
            }
          },
          {
            key: "option",
            fn: function(props) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(props.option.structured_formatting.main_text) +
                    "\n  "
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.selectedPlace,
          callback: function($$v) {
            _vm.selectedPlace = $$v
          },
          expression: "selectedPlace"
        }
      },
      "Multiselect",
      _vm.multiselectWorkaround,
      false
    ),
    [
      _vm._v(" "),
      _vm._v(" "),
      _c("template", { slot: "noResult" }, [
        _c("span", { staticClass: "multiselect__noresult" }, [
          _vm._v("\n      " + _vm._s(_vm.i18n.noResults) + "\n    ")
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }